import { StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getImpersonationUrlHandlerStyles(theme: Theme) {
  return StyleSheet.create({
    busyWrap: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.primary,
    },
  })
}
